import { fetcher } from '#lib/backendFetcher';

const BASE = '/api/v1/email/tone-of-voices';

/**
 * Fetches all tones of voice (system and custom).
 * @returns {Promise<Array<Object>>}
 */
export const fetchToneOfVoices = async () => {
	const { tones } = await fetcher(BASE);
	return tones;
};

/**
 * Creates a custom tone of voice.
 * @param {Object} tone
 * @param {string} tone.name - Name of the tone of voice
 * @param {string} tone.shortDescription - Short description
 * @param {string} tone.aiPromptInstructions - AI prompt instructions
 * @param {{min: number, max: number}} [tone.targetWordCount] - Target word count
 * @param {Array<string>} [tone.recommendedFor] - Recommended use cases
 * @returns {Promise<Object>}
 */
export const createToneOfVoice = async (tone) => {
	return fetcher(BASE, {
		method: 'POST',
		body: {
			name: tone.name,
			shortDescription: tone.shortDescription,
			aiPromptInstructions: tone.aiPromptInstructions,
			targetWordCount: tone.targetWordCount || { min: 80, max: 120 },
			recommendedFor: tone.recommendedFor || [],
		},
	});
};

/**
 * Updates a custom tone of voice.
 * @param {string} toneId - UUID of the tone of voice
 * @param {Object} updates - Fields to update
 * @returns {Promise<Object>}
 */
export const updateToneOfVoice = async (toneId, updates) => {
	return fetcher(`${BASE}/${toneId}`, {
		method: 'PATCH',
		body: updates,
	});
};

/**
 * Deletes a custom tone of voice.
 * @param {string} toneId - UUID of the tone of voice
 * @returns {Promise<Object>}
 */
export const deleteToneOfVoice = async (toneId) => {
	return fetcher(`${BASE}/${toneId}`, { method: 'DELETE' });
};
